<template>
  <TopBar :show-log-out="false"></TopBar>
  <div class="not-found-text">
    <p>{{ $t('not_found.heading') }}</p>
    <i18n-t keypath="not_found.heading_1" tag="p">
      <template v-slot:here>
        <a href="/">{{ $t('not_found.here') }}</a>
      </template>
    </i18n-t>
  </div>
</template>

<script>
import TopBar from '@/components/TopbarElement';

export default {
  components: { TopBar },
};
</script>

<style lang="scss" scoped>
.not-found-text {
  width: 85%;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  a {
    color: #00aeff;
  }
}
</style>
